module.exports = __webpack_public_path__ + "static/media/8.d51e43a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格选中态/8.png
// module id = 1634
// module chunks = 0